import kontax from "./modules/KontaxApi";

const kontaxApi = { kontax };

export default kontaxApi;
